import { RootDispatch } from 'store/types';
import analyticsService, { AnalyticsEvent } from 'services/AnalyticsService';
import { authenticateUser } from 'store/authentication/actions';

/**
 * Method: handleLoginPress
 * Description: It handles the login action that is preformed through the app.
 */
export const handleLoginPress = (currentUrl?: string) => (dispatch: RootDispatch) => {
  if (currentUrl) {
    analyticsService.logEvent(AnalyticsEvent.SignInTriggered, {
      currentUrl
    });
  }
  dispatch(authenticateUser());
};
